import { FC } from 'react';
import styled from '@emotion/styled';
import { useSetAtom } from 'jotai';
import Script from 'next/script';
import { useTranslation } from 'next-i18next';
import IcPolicyOptions from 'src/assets/images/icPrivacyOptionsGreen.svg';
import ImgAzarAppIcon from 'src/assets/images/imgAzarAppIcon.svg';
import Button from 'src/components/Button';
import withWebClientValidation from 'src/components/HOC/withWebClientValidation';
import TextLogo from 'src/components/Logo/TextLogo';
import useTheme from 'src/hooks/useTheme';
import { isUseKeepAliveAtom } from 'src/network/atoms';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { getAppsflyerDownloadUrl } from 'src/utils/appsflyer';
import { pushEvent } from 'src/utils/event-gateway';
import { ONETRUST_COOKIE_CATEGORY, isCookieCategoryConsented } from 'src/utils/onetrust';
const RootStyle = styled.div`
  display: flex;
  background-color: ${({
  theme
}) => theme.color.bg1};
  align-items: center;
  width: 100%;
  height: 100%;
  flex-direction: column;
  margin: 0px;
`;
const Header = styled.div`
  width: 100%;
  display: flex;
  height: 54px;
  justify-content: center;
  align-items: center;
`;
const DownloadButton = styled(Button)`
  margin-top: 32px;
  width: 218px;
`;
const Logo = styled(ImgAzarAppIcon)`
  margin-top: 120px;
  border-radius: 20px;
`;
const PolicyOptionsButton = styled.button`
  cursor: pointer;
  background-color: transparent;
  position: absolute;
  bottom: 40px;
  display: flex;
  align-items: center;
  gap: 6.6px;

  color: ${({
  theme
}) => theme.color.content9};
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
`;
const APPSFLYER_DEFAULT_URL = 'https://azarlive.onelink.me/fHTc/219bzu40';
const getDownloadUrl = (): string => {
  const downloadUrl = getAppsflyerDownloadUrl();
  return isCookieCategoryConsented(ONETRUST_COOKIE_CATEGORY.TARGETING) && downloadUrl ? downloadUrl : APPSFLYER_DEFAULT_URL;
};
const DownloadView: FC = () => {
  const {
    t
  } = useTranslation();
  const setIsUseKeepAlive = useSetAtom(isUseKeepAliveAtom);
  const theme = useTheme();
  const handleDownloadClick = async () => {
    setIsUseKeepAlive(true);
    pushEvent({
      eventType: EVENT_TYPE.WEB2APP,
      eventName: EVENT_NAME.ANYWHERE__CLICK_TO_APP_BTN,
      eventParams: {
        action_category: 'click',
        tab: 'download',
        page: 'main',
        target: 'to_app_btn',
        button_type: 'universal',
        referrer: 'download_page'
      }
    });
    window.location.href = getDownloadUrl();
  };
  return <>
      <Script id='appsflyer' src='/appsflyer.js' data-sentry-element="Script" data-sentry-source-file="Download.tsx" />
      <RootStyle data-sentry-element="RootStyle" data-sentry-source-file="Download.tsx">
        <Header data-sentry-element="Header" data-sentry-source-file="Download.tsx">
          <TextLogo width={72.96} height={20} ptHeight={20} ptWidth={97.2} arHeight={24} arWidth={32.2} color={theme.color.contentDeep} data-sentry-element="TextLogo" data-sentry-source-file="Download.tsx" />
        </Header>
        <Logo width={92} height={92} data-sentry-element="Logo" data-sentry-source-file="Download.tsx" />
        <DownloadButton id='download-button' onClick={handleDownloadClick} data-sentry-element="DownloadButton" data-sentry-source-file="Download.tsx">
          {t('download')}
        </DownloadButton>
        <PolicyOptionsButton onClick={() => window.OneTrust.ToggleInfoDisplay()} data-sentry-element="PolicyOptionsButton" data-sentry-source-file="Download.tsx">
          {t('footer_cookie_settings')}
          <IcPolicyOptions data-sentry-element="IcPolicyOptions" data-sentry-source-file="Download.tsx" />
        </PolicyOptionsButton>
      </RootStyle>
    </>;
};
export default withWebClientValidation(DownloadView);